import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService,
  Box3InkomenUitSparenEnBeleggen, IncomeTaxEntity,
  OmschrijvingEnBedrag
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SPINNER_TIMEOUT} from "../../gedeelde-componenten/gedeelde-componenten.component";
import { Event, NavigationEnd, Router } from "@angular/router";
import { filter, Subscription } from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector:
    'snelstart-venture-fiscaal-feature-box3-overige-periodieke-uitkeringen',
  templateUrl: './box3-overige-periodieke-uitkeringen.component.html',
  styleUrls: ['./box3-overige-periodieke-uitkeringen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class Box3OverigePeriodiekeUitkeringenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;

    public periodiekeUitkeringen = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.periodiekeUitkeringen = this.fb.group({
            box3PeriodiekeUitkeringen:
                this.fb.array<Box3InkomenUitSparenEnBeleggen>([])
        })
    }

    get box3PeriodiekeUitkeringen(): FormArray {
        return this.periodiekeUitkeringen.get('box3PeriodiekeUitkeringen') as FormArray;
    }

    addRijPeriodiekeUitkeringen(): void {
        this.box3PeriodiekeUitkeringen.push(this.createPeriodiekeUitkeringenFormGroup()
        )
    }

    verwijderRijPeriodiekeUitkeringen(index: number): void {
        this.box3PeriodiekeUitkeringen.removeAt(index);
        this.periodiekeUitkeringen.updateValueAndValidity()
        this.periodiekeUitkeringen.markAsDirty()
        this.saveForm()
    }



    createPeriodiekeUitkeringenFormGroup(pu?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: pu ? pu.omschrijving : undefined,
            bedrag: pu ? pu.bedrag : undefined,
        } as OmschrijvingEnBedrag))
    }

    public ngOnInit(): void {
    this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving&& this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.periodiekeUitkeringen.dirty
  }

    private updateForm(): void {
        const periodiekeUitkeringenLijst = this.incomeTaxEntity.aangifte?.box3?.periodiekeUitkeringen || [];
        const formArray = this.periodiekeUitkeringen.get('box3PeriodiekeUitkeringen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > periodiekeUitkeringenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < periodiekeUitkeringenLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(periodiekeUitkeringenLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createPeriodiekeUitkeringenFormGroup(periodiekeUitkeringenLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity?.aangifte,
                box3: {
                    ...this.incomeTaxEntity?.aangifte?.box3,
                    periodiekeUitkeringen: this.periodiekeUitkeringen.value.box3PeriodiekeUitkeringen
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        }, 200)
    }
}
